import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ReactiveFormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { TranslateModule } from '@ngx-translate/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { CheckProductionDatesComponent } from './components/check-production-dates/check-production-dates.component';
import { CheckProductionDatesFormComponent } from './components/check-production-dates/components/check-production-dates-form/check-production-dates-form.component';
import { CheckProductionDatesResultComponent } from './components/check-production-dates/components/check-production-dates-result/check-production-dates-result.component';
import { CheckProductionDatesInfoComponent } from './components/check-production-dates/components/check-production-dates-info/check-production-dates-info.component';

@NgModule({
  declarations: [
    CheckProductionDatesComponent,
    CheckProductionDatesInfoComponent,
    CheckProductionDatesFormComponent,
    CheckProductionDatesResultComponent,
  ],
  imports: [
    CommonModule,
    NzFormModule,
    ReactiveFormsModule,
    NzInputModule,
    NzSelectModule,
    TranslateModule,
    NzAlertModule,
    NzButtonModule,
    NzTableModule,
    NzSpinModule,
    NzIconModule,
  ],
  exports: [],
})
export class CheckProductionDatesModule {}
